import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import { ElLoading } from 'element-plus'
import api from "@/comment/request/api";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    },
  },
  // 其他内容
  {
    path: '/BottomCenter',
    name: 'BottomCenter',
    component: () => import('../views/Home/Components/BottomCenter'),
    meta: {
      path: '/BottomCenter'
    }
  },
  // 建设中
  {
    path: '/PageDevelopment',
    name: 'PageDevelopment',
    component: () => import('../views/develop/index'),
    meta: {
      path: '/',
      NoRoute: true
    }
  },
  //404
  {
    path: '/404',
    name: '404',
    component: () => import('../components/404')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  },
  // 登录
  {
    path: '/LoginPage',
    name: 'LoginPage',
    meta: {
      path: '/',
      center: 'login'
    },
    component: () => import('../views/Home/LoginPage'),
  },
  // 个人中心
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    meta: {
      path: '/',
      center: 'person'
    },
    component: () => import('../views/user/index'),
  },

  {
    path: '/About',
    name: 'About',
    component: () => import('../views/about/index')
  },
  // 视频
  {
    path: '/Video',
    name: 'Video',
    component: () => import('../views/video/index')
  },
  //视频详情页
  {
    path: '/VideoDetails',
    name: 'VideoDetails',
    component: () => import('../views/video/detail'),
    meta: {
      path: '/Video',
      NoRoute: true
    }
  },
  {
    path: '/Standard',
    name: 'Standard',
    component: () => import('../views/standard/index')
  },
  {
    path: '/Banner',
    name: 'Banner',
    component: () => import('../views/banner/index')
  },
  {
    path: '/BannerDetails',
    name: 'BannerDetails',
    component: () => import('../views/banner/detail'),
    meta: {
      path: '/',
      NoRoute: true
    }
  },

  {
    path: '/Notice',
    name: 'Notice',
    component: () => import('../views/notice/index')
  },
  {
    path: '/NoticeDetails',
    name: 'NoticeDetails',
    component: () => import('../views/notice/detail'),
    meta: {
      path: '/Notice',
      NoRoute: true
    }
  },

  {
    path: '/News',
    name: 'News',
    component: () => import('../views/news/index')
  },
  {
    path: '/NewsDetails',
    name: 'NewsDetails',
    component: () => import('../views/news/detail'),
    meta: {
      path: '/News',
      NoRoute: true
    }
  },

  {
    path: '/Member',
    name: 'Member',
    component: () => import('../views/member/index')
  },
  {
    path: '/MemberDetails',
    name: 'MemberDetails',
    component: () => import('../views/member/detail'),
    meta: {
      path: '/Member',
      NoRoute: true
    }
  },
  {
    path: '/MemberNews',
    name: 'MemberNews',
    component: () => import('../views/member_news/index'),
    meta: {
      path: '/Member',
      NoRoute: true
    }
  },
  {
    path: '/MemberNewsDetails',
    name: 'MemberNewsDetails',
    component: () => import('../views/member_news/detail'),
    meta: {
      path: '/Member',
      NoRoute: true
    }
  },

  {
    path: '/Teams',
    name: 'Teams',
    component: () => import('../views/teams/index'),
    meta: {
      path: '/Teams',
      NoRoute: true
    }
  },
  {
    path: '/TeamsDetails',
    name: 'TeamsDetails',
    component: () => import('../views/teams/detail'),
    meta: {
      path: '/Teams',
      NoRoute: true
    }
  },
  {
    path: '/TeamsHome',
    name: 'TeamsHome',
    component: () => import('../views/teams/home'),
    meta: {
      path: '/Teams',
      NoRoute: true
    }
  },
]
// 路由
const router = createRouter({
  history: createWebHashHistory(),
  routes
})
// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;
function startLoading() {
  loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: 'rgba(255,255, 255, 1)',
    customClass: 'loading_areaMain',
    target: document.querySelector('.loading-area')//设置加载动画区域
  });
}
function endLoading() {
  loading.close();
}
//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    // startLoading();
  }
  needLoadingRequestCount++;
};
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    // endLoading();
  }
};

// 进入路由前方法勾子
router.beforeEach((to, from, next) => {
  /*
    to 目标路由
    from 源路由
    next 跳转到下一个路由
  */
  api.GetConfigs('plat_name,plat_keywords,plat_description').success((res) => {
    let keyArr = {
      title: [],
      keywords: [],
      description: []
    };
    if (res.data.data) {
      keyArr.title.push(res.data.data.plat_name)
      keyArr.keywords.push(res.data.data.plat_keywords)
      keyArr.description.push(res.data.data.plat_description)
      window.localStorage.setItem('keysSeo', JSON.stringify(keyArr))
    }
  })

  if (to.meta?.topic) {
    window.startLoading();
  }

  /*加载loading*/
  showFullScreenLoading();
  next();
});
// 进入路由后方法勾子
router.afterEach((to, from) => {
  /*
    to 目标路由
    from 源路由
  */
  /*进入非首页页面到顶部*/
  if (to.name !== 'Home') {
    window.scrollTo(0, 0);
  }

  /*取消loading*/
  setTimeout(() => {
    tryHideFullScreenLoading();
  }, 500)
});
export default router
